/**
 * @package  	Cavalree_Infatree_Theme
 * @copyright	Copyright (c) 2021 Infantree (https://infantree.com/)
 * @version  	1.0.0
 *
 */

if (typeof $ === "undefined") {
  var $ = jQuery;
}

/*****************************
 * Vanilla JS functions
 *****************************/
// addHeadingNonBreakingSpace();
detectScrollbarWidth();
// END Vanilla JS

/*****************************
 * jQuery Ready
 *****************************/
$(document).ready(function () {
  scrollingStickyHeader();

  if ($(".book-series__series--list").length) {
    seriesScrolling();
  }

  $(window).scroll(function () {
    scrollingStickyHeader();
  });

  $(window).resize(function () {
    scrollingStickyHeader();
  });

  $("a.wp-block-button__link").each(function (index) {
    var html = $(this)[0].innerHTML;
    $(this)[0].innerHTML = html + '<i class="icon-arrow-sharp"></i>';
  });

  $(
    "body.book-series--parent .book-series__series button.wp-element-button"
  ).on("click", function (e) {
    e.preventDefault();
    var _this = $(this);

    $(".book-series__series--list").toggleClass("collapsed");

    if (!$(".book-series__series--list").hasClass("collapsed")) {
      _this.text("Shelve Extras");
    } else {
      _this.text("View All");
    }
  });
});

function seriesScrolling() {
  const scrollContainers = document.querySelectorAll(
    ".book-series .book-series__series > .container"
  );

  scrollContainers.forEach((container) => {
    const scrollWrap = container.querySelector(".book-series__series--list");
    const scrollButtons = container.querySelector(".series-scroll-btns");
    const scrollLeft = scrollButtons.querySelector(".scrollBtn_prev");
    const scrollRight = scrollButtons.querySelector(".scrollBtn_next");

    var scrollDistance = scrollWrap.clientWidth;
    var scrollWidth = scrollWrap.scrollWidth;

    if (scrollWidth > container.scrollWidth) {
      scrollButtons.classList.remove("hidden");
    }

    window.addEventListener("resize", function () {
      scrollWidth = scrollWrap.scrollWidth;

      if (scrollWidth > container.scrollWidth) {
        scrollButtons.classList.remove("hidden");
      } else {
        scrollButtons.classList.add("hidden");
      }
    });

    scrollLeft.classList.add("is-disabled");

    scrollLeft.onclick = function () {
      scrollWrap.scrollLeft -= scrollDistance * 0.5;
    };

    scrollRight.onclick = function () {
      scrollWrap.scrollLeft += scrollDistance * 0.5;
    };

    scrollWrap.addEventListener("scroll", (event) => {
      let style = window.getComputedStyle(scrollWrap);

      if (scrollWrap.scrollLeft == 0) {
        scrollLeft.classList.add("is-disabled");
      } else if (scrollWrap.scrollLeft > 0) {
        scrollLeft.classList.remove("is-disabled");
      }

      if (
        Number(
          scrollWidth -
            scrollDistance -
            scrollWrap.scrollLeft -
            parseInt(style.paddingLeft)
        ) <= 50
      ) {
        scrollRight.classList.add("is-disabled");
      } else {
        scrollRight.classList.remove("is-disabled");
      }
    });
  });
}

function scrollingStickyHeader() {
  var winTop = $(window).scrollTop(),
    stkHeadHeight = 70,
    check = winTop - 70;

  if (check >= 0 && check >= stkHeadHeight) {
    $(".site-header__main--home").addClass("is-active");
  } else {
    if (check < 0) {
      $(".site-header__main--home").removeClass("is-active");
    }
  }
}

// END jQuery Ready
function detectScrollbarWidth() {
  /* Detect scrollbar width to properly center full- and wide-width elements */
  let root = document.documentElement;
  var outside = document.createElement("div");
  var inside = document.createElement("div");

  outside.style.width = inside.style.width = "100%";
  outside.style.overflow = "scroll";
  document.body.appendChild(outside).appendChild(inside);

  var scrollbarWidth = outside.offsetWidth - inside.offsetWidth;

  outside.parentNode.removeChild(outside);
  root.style.setProperty("--scrollbar-width", scrollbarWidth + "px");
}

function addHeadingNonBreakingSpace() {
  var headings = document.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach(function (head, index) {
    let str = head.textContent;
    let firstSection = str.substring(0, str.lastIndexOf(" ") + 1);
    let lastSection = str.substring(str.lastIndexOf(" ") + 1, str.length);

    firstSection = firstSection.trim();

    let newStr = firstSection + "\u00a0" + lastSection;

    head.innerHTML = newStr;
  });
}

window.addEventListener("load", function () {
  function hidePreLoader() {
    var preloader = $(".screen__loader");
    setTimeout(function () {
      preloader.fadeOut(500);
    }, 1000);
  }

  hidePreLoader();
});
